import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#000000' cx='12' cy='12' r='12' />,
    <circle key='1' fill='#FFFFFF' cx='12' cy='12' r='10' />,
    <path
      key='2'
      fill='#000000'
      d='M18.1,8.2L18.1,8.2l-2.6-2.6l-0.7,0.7l1.4,1.4c-0.6,0.3-1.1,0.9-1.1,1.6c0,1,0.8,1.7,1.7,1.7c0.3,0,0.5-0.1,0.7-0.2v5
	c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-3.2c0-0.7-0.6-1.4-1.4-1.4H14V6.7c0-0.7-0.6-1.4-1.4-1.4H8.5C7.8,5.3,7.2,6,7.2,6.7
	v11.1h7v-5.3h1.1V16c0,1,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7V9.5C18.7,9,18.4,8.6,18.1,8.2z M12.7,10.1H8.5V6.7h4.2V10.1z
	 M16.8,10.1c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7S17.3,10.1,16.8,10.1z'
    />,
  ],
  'TransportConditionGeofenceEmpty'
);

const TransportConditionGeofenceEmptyIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(TransportConditionGeofenceEmptyIcon);
